/// <reference types="./state.d.mts" />
import * as $remote from "../../../app_config/app_config/remote.mjs";
import * as $auth0 from "../../../auth0_client/auth0/client.mjs";
import * as $comment from "../../../common/data/comment.mjs";
import * as $connector_settings from "../../../common/data/connector_settings.mjs";
import * as $data_point from "../../../common/data/data_point.mjs";
import * as $proposal_builder from "../../../common/data/ephemeral/proposal_builder.mjs";
import * as $insight from "../../../common/data/insight.mjs";
import * as $maintenance from "../../../common/data/maintenance.mjs";
import * as $metrics from "../../../common/data/metrics.mjs";
import * as $notification from "../../../common/data/notification.mjs";
import * as $project from "../../../common/data/project.mjs";
import * as $proposal from "../../../common/data/proposal.mjs";
import * as $qualification_matrix from "../../../common/data/qualification_matrix.mjs";
import * as $status from "../../../common/data/status.mjs";
import * as $translate from "../../../common/data/translate.mjs";
import * as $language from "../../../common/data/translate/language.mjs";
import * as $user from "../../../common/data/user.mjs";
import * as $assoc from "../../../common_common/gleam/assoc.mjs";
import * as $extra from "../../../common_common/gleam/list/extra.mjs";
import * as $position from "../../../ds/ds/internals/position.mjs";
import * as $window from "../../../ds/web/browser/window.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $timestamp from "../../../gleam_time/gleam/time/timestamp.mjs";
import * as $effect from "../../../lustre/lustre/effect.mjs";
import * as $connectors from "../../data/connectors.mjs";
import * as $content_library from "../../data/content_library.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $organization from "../../data/organization.mjs";
import * as $proposals from "../../data/proposals.mjs";
import * as $route from "../../data/route.mjs";
import * as $copilot from "../../data/ui/copilot.mjs";
import * as $loading from "../../data/ui/loading.mjs";
import * as $feature_flags from "../../feature_flags.mjs";
import * as $navigator from "../../frontend/browser/navigator.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  NonEmpty as $NonEmpty,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
  isEqual,
} from "../../gleam.mjs";
import { readPermissions as read_permissions } from "./state.ffi.ts";

const FILEPATH = "src/data/model/state.gleam";

export class State extends $CustomType {
  constructor(window_dimensions, access_token, analytics, client, collapsed_navbar, comments, comments_draft_mentions, comments_in_edition, connectors, content_library, copilot, custom_rewording_input, draft_comments, dropdown_unsubscriber, feed_opened, language, loading, modal, modal_unsubscriber, notifications, notifications_unread, opened_projects, organization, permissions, projects, proposal_builder, proposals, qualification_matrix, route, running_requests, translations, user, sources_tooltip, sources_tooltip_unsubscriber, maintenance) {
    super();
    this.window_dimensions = window_dimensions;
    this.access_token = access_token;
    this.analytics = analytics;
    this.client = client;
    this.collapsed_navbar = collapsed_navbar;
    this.comments = comments;
    this.comments_draft_mentions = comments_draft_mentions;
    this.comments_in_edition = comments_in_edition;
    this.connectors = connectors;
    this.content_library = content_library;
    this.copilot = copilot;
    this.custom_rewording_input = custom_rewording_input;
    this.draft_comments = draft_comments;
    this.dropdown_unsubscriber = dropdown_unsubscriber;
    this.feed_opened = feed_opened;
    this.language = language;
    this.loading = loading;
    this.modal = modal;
    this.modal_unsubscriber = modal_unsubscriber;
    this.notifications = notifications;
    this.notifications_unread = notifications_unread;
    this.opened_projects = opened_projects;
    this.organization = organization;
    this.permissions = permissions;
    this.projects = projects;
    this.proposal_builder = proposal_builder;
    this.proposals = proposals;
    this.qualification_matrix = qualification_matrix;
    this.route = route;
    this.running_requests = running_requests;
    this.translations = translations;
    this.user = user;
    this.sources_tooltip = sources_tooltip;
    this.sources_tooltip_unsubscriber = sources_tooltip_unsubscriber;
    this.maintenance = maintenance;
  }
}

export class MaintenanceMode extends $CustomType {
  constructor(org, frozen) {
    super();
    this.org = org;
    this.frozen = frozen;
  }
}

export class NoModal extends $CustomType {}

export class DeleteDataSource extends $CustomType {
  constructor(id) {
    super();
    this.id = id;
  }
}

export class DeleteProposal extends $CustomType {
  constructor(id) {
    super();
    this.id = id;
  }
}

export class DeleteProposalQuestion extends $CustomType {
  constructor(proposal_id, question_id) {
    super();
    this.proposal_id = proposal_id;
    this.question_id = question_id;
  }
}

export class DangerousQualificationMatrix extends $CustomType {}

export class IncompleteQualificationMatrix extends $CustomType {}

export class ChangeProjectStatus extends $CustomType {
  constructor(project_id, status) {
    super();
    this.project_id = project_id;
    this.status = status;
  }
}

export class RetriggerProposalQuestions extends $CustomType {
  constructor(proposal_id, override_validated) {
    super();
    this.proposal_id = proposal_id;
    this.override_validated = override_validated;
  }
}

export class DeleteProject extends $CustomType {
  constructor(id, confirm_input) {
    super();
    this.id = id;
    this.confirm_input = confirm_input;
  }
}

export class Init extends $CustomType {
  constructor(route, client, collapsed_navbar) {
    super();
    this.route = route;
    this.client = client;
    this.collapsed_navbar = collapsed_navbar;
  }
}

export function set_modal(state, modal) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function set_copilot(state, copilot) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function update_route(state, route) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function update_custom_rewording_input(state, value) {
  let custom_rewording_input = value;
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function update_draft_comment(state, value, target_id) {
  let _block;
  let _pipe = state.draft_comments;
  _block = $dict.insert(_pipe, target_id, value);
  let draft_comments = _block;
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function mark_as_loaded(state, mapper) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    mapper(state.loading),
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function set_language(state, language) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function find_project_of_proposal_id(state, proposal_id) {
  let _pipe = state.proposals.all;
  let _pipe$1 = $list.key_find(_pipe, proposal_id);
  return $result.try$(
    _pipe$1,
    (proposal) => {
      let _pipe$2 = state.projects;
      return $list.key_find(_pipe$2, proposal.id);
    },
  );
}

export function update_sources_tooltip(state, sources_tooltip) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    sources_tooltip,
    new None(),
    _record.maintenance,
  );
}

export function update_access_token(state, access_token) {
  let _pipe = read_permissions(access_token);
  let _pipe$1 = $result.replace_error(_pipe, toList([]));
  let _pipe$2 = $result.try$(
    _pipe$1,
    (_capture) => { return $decode.run(_capture, $decode.list($decode.string)); },
  );
  let _pipe$3 = $result.unwrap(_pipe$2, toList([]));
  return ((permissions) => {
    let _record = state;
    return new State(
      _record.window_dimensions,
      new Some(access_token),
      _record.analytics,
      _record.client,
      _record.collapsed_navbar,
      _record.comments,
      _record.comments_draft_mentions,
      _record.comments_in_edition,
      _record.connectors,
      _record.content_library,
      _record.copilot,
      _record.custom_rewording_input,
      _record.draft_comments,
      _record.dropdown_unsubscriber,
      _record.feed_opened,
      _record.language,
      _record.loading,
      _record.modal,
      _record.modal_unsubscriber,
      _record.notifications,
      _record.notifications_unread,
      _record.opened_projects,
      _record.organization,
      permissions,
      _record.projects,
      _record.proposal_builder,
      _record.proposals,
      _record.qualification_matrix,
      _record.route,
      _record.running_requests,
      _record.translations,
      _record.user,
      _record.sources_tooltip,
      _record.sources_tooltip_unsubscriber,
      _record.maintenance,
    );
  })(_pipe$3);
}

export function update_connected_user(state, user) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    new Some(user),
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

function clear_popup(state) {
  let proposals = $proposals.clear_popup(state.proposals, state.route);
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    (() => {
      let _record$1 = state.content_library;
      return new $content_library.ContentLibrary(
        _record$1.stats,
        _record$1.change_expiration_date_input,
        _record$1.change_expiration_date_popup_opened,
        _record$1.change_owner_popup_opened,
        _record$1.change_status_popup_opened,
        _record$1.change_tags_popup_opened,
        _record$1.conflicts_data_points,
        _record$1.content_library_block_page_size,
        _record$1.dropdown_unsubscriber,
        _record$1.filter_selected,
        _record$1.filter_tag_selected,
        _record$1.filter_collaborator_selected,
        _record$1.filters_opened,
        _record$1.ingestion_loading,
        _record$1.ingestion_spreadsheet,
        _record$1.insights,
        _record$1.insight_filter_selected,
        _record$1.new_qna,
        _record$1.non_qna_sources,
        _record$1.qna_sources,
        _record$1.qna_page,
        _record$1.non_qna_page,
        _record$1.search,
        $dict.new$(),
        _record$1.selected_insight_data_point_id,
        _record$1.selected_insight_id,
      );
    })(),
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    false,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function is_connected(state) {
  return $option.is_some(state.access_token);
}

export function upsert_translations(state, t) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    (() => {
      let _pipe = t;
      let _pipe$1 = $list.map(_pipe, (t) => { return [t.id, t]; });
      let _pipe$2 = $dict.from_list(_pipe$1);
      return $dict.combine(
        _pipe$2,
        state.translations,
        (new$, _) => { return new$; },
      );
    })(),
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function delete_translations(state, s) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    $dict.filter(
      state.translations,
      (k, _) => {
        let $ = $string.split(k, "_");
        if (
          $ instanceof $Empty ||
          $.tail instanceof $Empty ||
          $.tail.tail instanceof $Empty ||
          $.tail.tail.tail instanceof $NonEmpty
        ) {
          throw makeError(
            "let_assert",
            FILEPATH,
            "data/model/state",
            250,
            "delete_translations",
            "Pattern match failed, no pattern matched the value.",
            {
              value: $,
              start: 7752,
              end: 7796,
              pattern_start: 7763,
              pattern_end: 7773
            }
          )
        }
        let id = $.tail.tail.head;
        return id !== s;
      },
    ),
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function reset_custom_rewording_input(state) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    "",
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function empty_opened_projects(state) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    $dict.new$(),
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function set_proposal_builder(state, proposal_builder) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function set_content_library(state, content_library) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function set_connectors(state, connectors) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function set_settings(state, settings) {
  let _record = state.connectors;
  return new $connectors.Connectors(
    _record.fetched,
    _record.confluence,
    _record.confluence_opened,
    _record.website_opened,
    _record.salesforce,
    _record.salesforce_opened,
    _record.confluence_input_page_url,
    _record.website_input_page_url,
    _record.website_sitemap_pages,
    _record.notion,
    _record.notion_opened,
    _record.google_input_folder_url,
    _record.google_drive_opened,
    settings,
  );
}

export function set_confluence_pages(state, pages) {
  let _pipe = state.connectors.settings;
  let _pipe$1 = $list.map(
    _pipe,
    (_capture) => {
      return $connector_settings.set_confluence_pages(_capture, pages);
    },
  );
  let _pipe$2 = ((_capture) => { return set_settings(state, _capture); })(
    _pipe$1,
  );
  return ((_capture) => { return set_connectors(state, _capture); })(_pipe$2);
}

export function get_confluence_pages(state) {
  let _pipe = state.connectors.settings;
  let _pipe$1 = $list.find(_pipe, $connector_settings.is_confluence);
  let _pipe$2 = $result.try$(_pipe$1, $connector_settings.pages);
  return $result.unwrap(_pipe$2, toList([]));
}

export function empty_confluence_input_page_url(state) {
  let _block;
  let _record = state.connectors;
  _block = new $connectors.Connectors(
    _record.fetched,
    _record.confluence,
    _record.confluence_opened,
    _record.website_opened,
    _record.salesforce,
    _record.salesforce_opened,
    "",
    _record.website_input_page_url,
    _record.website_sitemap_pages,
    _record.notion,
    _record.notion_opened,
    _record.google_input_folder_url,
    _record.google_drive_opened,
    _record.settings,
  );
  let _pipe = _block;
  return ((_capture) => { return set_connectors(state, _capture); })(_pipe);
}

export function set_website_pages(state, pages) {
  let _pipe = state.connectors.settings;
  let _pipe$1 = $list.map(
    _pipe,
    (_capture) => {
      return $connector_settings.set_website_pages(_capture, pages);
    },
  );
  let _pipe$2 = ((_capture) => { return set_settings(state, _capture); })(
    _pipe$1,
  );
  return ((_capture) => { return set_connectors(state, _capture); })(_pipe$2);
}

export function get_website_pages(state) {
  let _pipe = state.connectors.settings;
  let _pipe$1 = $list.find(_pipe, $connector_settings.is_website);
  let _pipe$2 = $result.try$(_pipe$1, $connector_settings.pages);
  return $result.unwrap(_pipe$2, toList([]));
}

export function empty_website_input_page_url(state) {
  let _block;
  let _record = state.connectors;
  _block = new $connectors.Connectors(
    _record.fetched,
    _record.confluence,
    _record.confluence_opened,
    _record.website_opened,
    _record.salesforce,
    _record.salesforce_opened,
    _record.confluence_input_page_url,
    "",
    _record.website_sitemap_pages,
    _record.notion,
    _record.notion_opened,
    _record.google_input_folder_url,
    _record.google_drive_opened,
    _record.settings,
  );
  let _pipe = _block;
  return ((_capture) => { return set_connectors(state, _capture); })(_pipe);
}

export function set_sitemap_pages(state, pages) {
  let _block;
  let _record = state.connectors;
  _block = new $connectors.Connectors(
    _record.fetched,
    _record.confluence,
    _record.confluence_opened,
    _record.website_opened,
    _record.salesforce,
    _record.salesforce_opened,
    _record.confluence_input_page_url,
    _record.website_input_page_url,
    pages,
    _record.notion,
    _record.notion_opened,
    _record.google_input_folder_url,
    _record.google_drive_opened,
    _record.settings,
  );
  let _pipe = _block;
  return ((_capture) => { return set_connectors(state, _capture); })(_pipe);
}

export function empty_sitemap_pages(state) {
  let _block;
  let _record = state.connectors;
  _block = new $connectors.Connectors(
    _record.fetched,
    _record.confluence,
    _record.confluence_opened,
    _record.website_opened,
    _record.salesforce,
    _record.salesforce_opened,
    _record.confluence_input_page_url,
    _record.website_input_page_url,
    toList([]),
    _record.notion,
    _record.notion_opened,
    _record.google_input_folder_url,
    _record.google_drive_opened,
    _record.settings,
  );
  let _pipe = _block;
  return ((_capture) => { return set_connectors(state, _capture); })(_pipe);
}

export function get_google_folder_urls(state) {
  let _pipe = state.connectors.settings;
  let _pipe$1 = $list.find(_pipe, $connector_settings.is_google_drive);
  let _pipe$2 = $result.try$(_pipe$1, $connector_settings.pages);
  return $result.unwrap(_pipe$2, toList([]));
}

export function set_google_folder_urls(state, pages) {
  let _pipe = state.connectors.settings;
  let _pipe$1 = $list.map(
    _pipe,
    (_capture) => {
      return $connector_settings.set_google_folder_urls(_capture, pages);
    },
  );
  let _pipe$2 = ((_capture) => { return set_settings(state, _capture); })(
    _pipe$1,
  );
  return ((_capture) => { return set_connectors(state, _capture); })(_pipe$2);
}

export function empty_google_input_folder_url(state) {
  let _block;
  let _record = state.connectors;
  _block = new $connectors.Connectors(
    _record.fetched,
    _record.confluence,
    _record.confluence_opened,
    _record.website_opened,
    _record.salesforce,
    _record.salesforce_opened,
    _record.confluence_input_page_url,
    _record.website_input_page_url,
    _record.website_sitemap_pages,
    _record.notion,
    _record.notion_opened,
    "",
    _record.google_drive_opened,
    _record.settings,
  );
  let _pipe = _block;
  return ((_capture) => { return set_connectors(state, _capture); })(_pipe);
}

export function set_proposals(state, proposals) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function empty_popup(state, id) {
  let is_feed = id === "feed";
  return $bool.guard(
    is_feed,
    (() => {
      let _record = state;
      return new State(
        _record.window_dimensions,
        _record.access_token,
        _record.analytics,
        _record.client,
        _record.collapsed_navbar,
        _record.comments,
        _record.comments_draft_mentions,
        _record.comments_in_edition,
        _record.connectors,
        _record.content_library,
        _record.copilot,
        _record.custom_rewording_input,
        _record.draft_comments,
        _record.dropdown_unsubscriber,
        false,
        _record.language,
        _record.loading,
        _record.modal,
        _record.modal_unsubscriber,
        _record.notifications,
        _record.notifications_unread,
        _record.opened_projects,
        _record.organization,
        _record.permissions,
        _record.projects,
        _record.proposal_builder,
        _record.proposals,
        _record.qualification_matrix,
        _record.route,
        _record.running_requests,
        _record.translations,
        _record.user,
        _record.sources_tooltip,
        _record.sources_tooltip_unsubscriber,
        _record.maintenance,
      );
    })(),
    () => {
      return $bool.lazy_guard(
        id === "all",
        () => { return clear_popup(state); },
        () => {
          return set_proposals(
            state,
            (() => {
              if (id.startsWith("collaborator-")) {
                let id$1 = id.slice(13);
                return $proposals.close_collaborators(state.proposals, id$1);
              } else if (id.startsWith("ai-")) {
                let id$1 = id.slice(3);
                return $proposals.close_more_question(state.proposals, id$1);
              } else if (id === "proposal-filter") {
                return $proposals.close_filters(state.proposals);
              } else if (id.startsWith("proposal-")) {
                let id$1 = id.slice(9);
                return $proposals.close_more_proposal(state.proposals, id$1);
              } else if (id === "comment-more") {
                return $proposals.close_comment_more(state.proposals);
              } else if (id === "comment-emoji") {
                return $proposals.close_emoji_comment_picker(state.proposals);
              } else {
                return state.proposals;
              }
            })(),
          );
        },
      );
    },
  );
}

export function upsert_proposals(state, proposals) {
  let _pipe = $proposals.upsert_all(state.proposals, proposals);
  let _pipe$1 = ((_capture) => { return set_proposals(state, _capture); })(
    _pipe,
  );
  return mark_as_loaded(_pipe$1, $loading.proposals);
}

export function upsert_projects(state, projects) {
  let _pipe = $list.fold(
    projects,
    state.projects,
    (projects, project) => {
      return $list.key_set(projects, project.id, project);
    },
  );
  let _pipe$1 = $list.sort(
    _pipe,
    (a, b) => { return $timestamp.compare(b[1].created_at, a[1].created_at); },
  );
  let _pipe$2 = ((projects) => {
    let _record = state;
    return new State(
      _record.window_dimensions,
      _record.access_token,
      _record.analytics,
      _record.client,
      _record.collapsed_navbar,
      _record.comments,
      _record.comments_draft_mentions,
      _record.comments_in_edition,
      _record.connectors,
      _record.content_library,
      _record.copilot,
      _record.custom_rewording_input,
      _record.draft_comments,
      _record.dropdown_unsubscriber,
      _record.feed_opened,
      _record.language,
      _record.loading,
      _record.modal,
      _record.modal_unsubscriber,
      _record.notifications,
      _record.notifications_unread,
      _record.opened_projects,
      _record.organization,
      _record.permissions,
      projects,
      _record.proposal_builder,
      _record.proposals,
      _record.qualification_matrix,
      _record.route,
      _record.running_requests,
      _record.translations,
      _record.user,
      _record.sources_tooltip,
      _record.sources_tooltip_unsubscriber,
      _record.maintenance,
    );
  })(_pipe$1);
  return mark_as_loaded(_pipe$2, $loading.projects);
}

export function delete_project(state, project_id) {
  let _pipe = state.projects;
  let _pipe$1 = $list.filter(
    _pipe,
    (project) => { return project[0] !== project_id; },
  );
  let _pipe$2 = ((projects) => {
    let _record = state;
    return new State(
      _record.window_dimensions,
      _record.access_token,
      _record.analytics,
      _record.client,
      _record.collapsed_navbar,
      _record.comments,
      _record.comments_draft_mentions,
      _record.comments_in_edition,
      _record.connectors,
      _record.content_library,
      _record.copilot,
      _record.custom_rewording_input,
      _record.draft_comments,
      _record.dropdown_unsubscriber,
      _record.feed_opened,
      _record.language,
      _record.loading,
      _record.modal,
      _record.modal_unsubscriber,
      _record.notifications,
      _record.notifications_unread,
      _record.opened_projects,
      _record.organization,
      _record.permissions,
      projects,
      _record.proposal_builder,
      _record.proposals,
      _record.qualification_matrix,
      _record.route,
      _record.running_requests,
      _record.translations,
      _record.user,
      _record.sources_tooltip,
      _record.sources_tooltip_unsubscriber,
      _record.maintenance,
    );
  })(_pipe$1);
  return mark_as_loaded(_pipe$2, $loading.projects);
}

export function set_notifications(state, notifications) {
  let notifications_unread = $list.any(
    notifications,
    (n) => { return !n.read; },
  );
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    notifications,
    notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

function upsert_notification(notifications, notification) {
  if (notifications instanceof $Empty) {
    return new Error(undefined);
  } else {
    let n = notifications.head;
    let rest = notifications.tail;
    let $ = n.id === notification.id;
    if ($) {
      return new Ok(listPrepend(notification, rest));
    } else {
      let _pipe = upsert_notification(rest, notification);
      return $result.map(_pipe, (value) => { return listPrepend(n, value); });
    }
  }
}

export function set_notification(state, notification) {
  let _pipe = upsert_notification(state.notifications, notification);
  let _pipe$1 = $result.lazy_unwrap(
    _pipe,
    () => { return listPrepend(notification, state.notifications); },
  );
  return ((_capture) => { return set_notifications(state, _capture); })(_pipe$1);
}

export function find_user(state, user) {
  return $list.find(
    state.organization.users,
    (user_) => { return isEqual(new Some(user_.id), user); },
  );
}

export function find_current_user(state) {
  let connected_user = $option.map(state.user, (u) => { return u.sub; });
  return find_user(state, connected_user);
}

export function current_user(state) {
  let _pipe = $list.find(
    state.organization.users,
    (user) => {
      let connected_user = $option.map(state.user, (u) => { return u.sub; });
      return isEqual(new Some(user.id), connected_user);
    },
  );
  return $option.from_result(_pipe);
}

export function find_current_user_id(state) {
  let user = find_current_user(state);
  return $result.map(user, (u) => { return u.id; });
}

export function current_user_id(state) {
  let user = find_current_user(state);
  let _pipe = $result.map(user, (u) => { return u.id; });
  return $option.from_result(_pipe);
}

export function empty_proposal_builder(state) {
  let _block;
  let _pipe = current_user_id(state);
  _block = $option.unwrap(_pipe, "");
  let user = _block;
  let $ = state.route;
  if ($ instanceof $route.Projects) {
    let $1 = $[0];
    if ($1 instanceof $route.AddProject) {
      let $2 = $1.loading;
      if (!$2) {
        let pb = $proposal_builder.init(new $proposal_builder.NewProject());
        let _record = state;
        return new State(
          _record.window_dimensions,
          _record.access_token,
          _record.analytics,
          _record.client,
          _record.collapsed_navbar,
          _record.comments,
          _record.comments_draft_mentions,
          _record.comments_in_edition,
          _record.connectors,
          _record.content_library,
          _record.copilot,
          _record.custom_rewording_input,
          _record.draft_comments,
          _record.dropdown_unsubscriber,
          _record.feed_opened,
          _record.language,
          _record.loading,
          _record.modal,
          _record.modal_unsubscriber,
          _record.notifications,
          _record.notifications_unread,
          _record.opened_projects,
          _record.organization,
          _record.permissions,
          _record.projects,
          pb,
          _record.proposals,
          _record.qualification_matrix,
          _record.route,
          _record.running_requests,
          _record.translations,
          _record.user,
          _record.sources_tooltip,
          _record.sources_tooltip_unsubscriber,
          _record.maintenance,
        );
      } else {
        return state;
      }
    } else if ($1 instanceof $route.AddProposal) {
      let $2 = $1.loading;
      if (!$2) {
        let pb = $proposal_builder.init(new $proposal_builder.NewProposal());
        let _record = state;
        return new State(
          _record.window_dimensions,
          _record.access_token,
          _record.analytics,
          _record.client,
          _record.collapsed_navbar,
          _record.comments,
          _record.comments_draft_mentions,
          _record.comments_in_edition,
          _record.connectors,
          _record.content_library,
          _record.copilot,
          _record.custom_rewording_input,
          _record.draft_comments,
          _record.dropdown_unsubscriber,
          _record.feed_opened,
          _record.language,
          _record.loading,
          _record.modal,
          _record.modal_unsubscriber,
          _record.notifications,
          _record.notifications_unread,
          _record.opened_projects,
          _record.organization,
          _record.permissions,
          _record.projects,
          pb,
          _record.proposals,
          _record.qualification_matrix,
          _record.route,
          _record.running_requests,
          _record.translations,
          _record.user,
          _record.sources_tooltip,
          _record.sources_tooltip_unsubscriber,
          _record.maintenance,
        );
      } else {
        return state;
      }
    } else if ($1 instanceof $route.EditProject) {
      let project_id = $1.project_id;
      let _record = state;
      return new State(
        _record.window_dimensions,
        _record.access_token,
        _record.analytics,
        _record.client,
        _record.collapsed_navbar,
        _record.comments,
        _record.comments_draft_mentions,
        _record.comments_in_edition,
        _record.connectors,
        _record.content_library,
        _record.copilot,
        _record.custom_rewording_input,
        _record.draft_comments,
        _record.dropdown_unsubscriber,
        _record.feed_opened,
        _record.language,
        _record.loading,
        _record.modal,
        _record.modal_unsubscriber,
        _record.notifications,
        _record.notifications_unread,
        _record.opened_projects,
        _record.organization,
        _record.permissions,
        _record.projects,
        (() => {
          let project = $assoc.get(state.projects, project_id);
          let edit_status = new $proposal_builder.EditProject(project_id);
          let builder = $proposal_builder.init(edit_status);
          let $2 = state.loading.users;
          if (!$2) {
            if (project instanceof Ok) {
              let project$1 = project[0];
              return $proposal_builder.as_project_edit(builder, project$1, user);
            } else {
              return builder;
            }
          } else {
            return builder;
          }
        })(),
        _record.proposals,
        _record.qualification_matrix,
        _record.route,
        _record.running_requests,
        _record.translations,
        _record.user,
        _record.sources_tooltip,
        _record.sources_tooltip_unsubscriber,
        _record.maintenance,
      );
    } else if ($1 instanceof $route.EditProposal) {
      let project_id = $1.project_id;
      let proposal_id = $1.proposal_id;
      let _record = state;
      return new State(
        _record.window_dimensions,
        _record.access_token,
        _record.analytics,
        _record.client,
        _record.collapsed_navbar,
        _record.comments,
        _record.comments_draft_mentions,
        _record.comments_in_edition,
        _record.connectors,
        _record.content_library,
        _record.copilot,
        _record.custom_rewording_input,
        _record.draft_comments,
        _record.dropdown_unsubscriber,
        _record.feed_opened,
        _record.language,
        _record.loading,
        _record.modal,
        _record.modal_unsubscriber,
        _record.notifications,
        _record.notifications_unread,
        _record.opened_projects,
        _record.organization,
        _record.permissions,
        _record.projects,
        (() => {
          let project = $assoc.get(state.projects, project_id);
          let proposal = $assoc.get(state.proposals.all, proposal_id);
          let edit_status = new $proposal_builder.EditProposal(
            project_id,
            proposal_id,
          );
          let builder = $proposal_builder.init(edit_status);
          if (proposal instanceof Ok) {
            if (project instanceof Ok) {
              let proposal$1 = proposal[0];
              let project$1 = project[0];
              let _pipe$1 = builder;
              let _pipe$2 = $proposal_builder.as_project_edit(
                _pipe$1,
                project$1,
                user,
              );
              return $proposal_builder.as_proposal_edit(_pipe$2, proposal$1);
            } else {
              return builder;
            }
          } else {
            return builder;
          }
        })(),
        _record.proposals,
        _record.qualification_matrix,
        _record.route,
        _record.running_requests,
        _record.translations,
        _record.user,
        _record.sources_tooltip,
        _record.sources_tooltip_unsubscriber,
        _record.maintenance,
      );
    } else {
      return state;
    }
  } else {
    return state;
  }
}

export function new$(init) {
  let _block;
  let _pipe = $navigator.language();
  _block = $result.unwrap(_pipe, new $language.English());
  let language = _block;
  let width = $window.inner_width($window.self());
  let height = $window.inner_height($window.self());
  let _pipe$1 = new State(
    [width, height],
    new $option.None(),
    toList([]),
    init.client,
    init.collapsed_navbar,
    toList([]),
    $dict.new$(),
    $dict.new$(),
    $connectors.new$(),
    $content_library.new$(),
    $copilot.new$(),
    "",
    $dict.new$(),
    new None(),
    false,
    language,
    $loading.new$(),
    new NoModal(),
    new None(),
    toList([]),
    false,
    $dict.new$(),
    $organization.new$(),
    toList([]),
    toList([]),
    $proposal_builder.init(new $proposal_builder.NewProject()),
    $proposals.new$(),
    toList([]),
    init.route,
    toList([]),
    $dict.new$(),
    new None(),
    new None(),
    new None(),
    new $remote.NotLoaded(),
  );
  return empty_proposal_builder(_pipe$1);
}

export function current_org_id(state) {
  return $option.then$(state.user, (u) => { return u.org_id; });
}

export function is_organization_allowed(state, feature_flag) {
  let _pipe = current_org_id(state);
  let _pipe$1 = $option.map(
    _pipe,
    (_capture) => { return $feature_flags.authorized(_capture, feature_flag); },
  );
  return $option.unwrap(_pipe$1, false);
}

export function is_qualification_matrix_hidden(state) {
  return !is_organization_allowed(
    state,
    new $feature_flags.QualificationMatrix(),
  );
}

export function is_analytics_hidden(state) {
  return !is_organization_allowed(state, new $feature_flags.Analytics());
}

export function are_insights_hidden(state) {
  return !is_organization_allowed(state, new $feature_flags.Insights());
}

export function is_word_hidden(state) {
  return !is_organization_allowed(state, new $feature_flags.WordSupport());
}

export function is_narrative_hidden(state) {
  return !is_organization_allowed(state, new $feature_flags.NarrativeSupport());
}

export function is_admin(state) {
  let _pipe = current_user(state);
  let _pipe$1 = $option.map(_pipe, $user.is_admin);
  return $option.unwrap(_pipe$1, false);
}

export function is_super_admin(state) {
  let _pipe = current_user(state);
  let _pipe$1 = $option.map(_pipe, $user.is_super_admin);
  return $option.unwrap(_pipe$1, false);
}

export function is_translations_hidden(state) {
  return !is_organization_allowed(state, new $feature_flags.Translations());
}

export function upsert_insight(state, insight) {
  let _block;
  let _pipe = state.content_library.insights;
  _block = $extra.push(_pipe, insight);
  let insights = _block;
  let _block$1;
  let _record = state.content_library;
  _block$1 = new $content_library.ContentLibrary(
    _record.stats,
    _record.change_expiration_date_input,
    _record.change_expiration_date_popup_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.change_tags_popup_opened,
    _record.conflicts_data_points,
    _record.content_library_block_page_size,
    _record.dropdown_unsubscriber,
    _record.filter_selected,
    _record.filter_tag_selected,
    _record.filter_collaborator_selected,
    _record.filters_opened,
    _record.ingestion_loading,
    _record.ingestion_spreadsheet,
    insights,
    _record.insight_filter_selected,
    _record.new_qna,
    _record.non_qna_sources,
    _record.qna_sources,
    _record.qna_page,
    _record.non_qna_page,
    _record.search,
    _record.selected,
    _record.selected_insight_data_point_id,
    _record.selected_insight_id,
  );
  let _pipe$1 = _block$1;
  return ((_capture) => { return set_content_library(state, _capture); })(
    _pipe$1,
  );
}

export function upsert_conflicts_data_points(state, conflicts_data_points) {
  let _block;
  let _pipe = conflicts_data_points;
  let _pipe$1 = $list.map(_pipe, (d) => { return [d.id, d]; });
  let _pipe$2 = $dict.from_list(_pipe$1);
  _block = $dict.combine(
    _pipe$2,
    state.content_library.conflicts_data_points,
    (new$, _) => { return new$; },
  );
  let conflicts_data_points$1 = _block;
  let _block$1;
  let _record = state.content_library;
  _block$1 = new $content_library.ContentLibrary(
    _record.stats,
    _record.change_expiration_date_input,
    _record.change_expiration_date_popup_opened,
    _record.change_owner_popup_opened,
    _record.change_status_popup_opened,
    _record.change_tags_popup_opened,
    conflicts_data_points$1,
    _record.content_library_block_page_size,
    _record.dropdown_unsubscriber,
    _record.filter_selected,
    _record.filter_tag_selected,
    _record.filter_collaborator_selected,
    _record.filters_opened,
    _record.ingestion_loading,
    _record.ingestion_spreadsheet,
    _record.insights,
    _record.insight_filter_selected,
    _record.new_qna,
    _record.non_qna_sources,
    _record.qna_sources,
    _record.qna_page,
    _record.non_qna_page,
    _record.search,
    _record.selected,
    _record.selected_insight_data_point_id,
    _record.selected_insight_id,
  );
  let _pipe$3 = _block$1;
  return ((_capture) => { return set_content_library(state, _capture); })(
    _pipe$3,
  );
}

export function set_dropdown_unsubscriber(state, dropdown_unsubscriber) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function should_subscribe_dom_click(state) {
  return state.proposals.change_owner_popup_opened || state.proposals.change_status_popup_opened;
}

export function set_organization(state, organization) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function update_window_dimensions(state, window_dimensions) {
  let _record = state;
  return new State(
    window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function update_project_status(state, id, status) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    _record.comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    $list.map(
      state.projects,
      (project) => {
        return $bool.guard(
          project[0] !== id,
          project,
          () => {
            return $pair.map_second(
              project,
              (project) => {
                let _record$1 = project;
                return new $project.Project(
                  _record$1.id,
                  _record$1.name,
                  _record$1.owners,
                  _record$1.org_id,
                  _record$1.deadline,
                  _record$1.client,
                  _record$1.collaborators,
                  _record$1.metadata,
                  _record$1.created_at,
                  status,
                );
              },
            );
          },
        );
      },
    ),
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function set_draft_mentions(state, comments_draft_mentions) {
  let _record = state;
  return new State(
    _record.window_dimensions,
    _record.access_token,
    _record.analytics,
    _record.client,
    _record.collapsed_navbar,
    _record.comments,
    comments_draft_mentions,
    _record.comments_in_edition,
    _record.connectors,
    _record.content_library,
    _record.copilot,
    _record.custom_rewording_input,
    _record.draft_comments,
    _record.dropdown_unsubscriber,
    _record.feed_opened,
    _record.language,
    _record.loading,
    _record.modal,
    _record.modal_unsubscriber,
    _record.notifications,
    _record.notifications_unread,
    _record.opened_projects,
    _record.organization,
    _record.permissions,
    _record.projects,
    _record.proposal_builder,
    _record.proposals,
    _record.qualification_matrix,
    _record.route,
    _record.running_requests,
    _record.translations,
    _record.user,
    _record.sources_tooltip,
    _record.sources_tooltip_unsubscriber,
    _record.maintenance,
  );
}

export function empty_draft_mentions(state, comment_id) {
  let _pipe = state.comments_draft_mentions;
  let _pipe$1 = $dict.insert(_pipe, comment_id, toList([]));
  return ((_capture) => { return set_draft_mentions(state, _capture); })(
    _pipe$1,
  );
}
